var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import DOMPurify from "dompurify";
import QuestionnaireOrg from "../../../organisms/obligationsQuestionnaire/obligationsQuestionnaire";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { ClientObligationsAction, ClientObligationsFormAction, AdviserObligationsAction, } from "../../../../redux/actions/job_seeker_questionnaire";
import { getQuestionnaireAttemptVariant, getQuestionnaireProgressWidth, } from "../../../../utils/questionnaireProgress";
/**
 * The Client Obligations Questionnaire Page
 * This will need to call all relevant APIs to get the values.
 * @param props
 * @returns
 */
function ClientObligationsQuestionnaire() {
    var navigate = useNavigate();
    var dispatch = useDispatch();
    var _a = useState(""), error = _a[0], setError = _a[1];
    var _b = useState(false), isSubmitting = _b[0], setIsSubmitting = _b[1];
    //using selector hook to fetch data from the reducer
    var _c = useSelector(function (state) { return state.rootReducer.JobSeekerQuestionnaireReducer; }), clientObligationsData = _c.clientObligationsData, error_clientObligations = _c.error_clientObligations, loading = _c.loading, clientObligationsFormData = _c.clientObligationsFormData, adviserObligationsData = _c.adviserObligationsData, success_clientObligations_form = _c.success_clientObligations_form;
    var _d = useSelector(function (state) { return state.rootReducer.userReducer; }), loginData = _d.loginData, includeObligations = _d.includeObligations;
    useEffect(function () {
        // Antecedents prefetches this section already; only fetch if it's
        // not already cached in the store (e.g. direct navigation to this page).
        if (!clientObligationsData || clientObligationsData.length === 0) {
            dispatch(ClientObligationsAction());
        }
        // Prefetch the next section in the background, if not already cached.
        if (!adviserObligationsData || adviserObligationsData.length === 0) {
            dispatch(AdviserObligationsAction());
        }
    }, [dispatch]);
    var quesAttemptDetails = useSelector(function (state) { return state.rootReducer.dashboardReducer.quesAttemptDetails; });
    var isNonFirstAttempt = !!((quesAttemptDetails === null || quesAttemptDetails === void 0 ? void 0 : quesAttemptDetails.second_attempt_ready) ||
        (quesAttemptDetails === null || quesAttemptDetails === void 0 ? void 0 : quesAttemptDetails.milestone_questionnaire_ready));
    //function to submit the input user data
    var handleFormSubmit = function (formData) {
        var sanitizedData = Object.keys(formData).reduce(function (acc, key) {
            acc[key] = DOMPurify.sanitize(formData[key]);
            return acc;
        }, {});
        setIsSubmitting(true);
        dispatch(ClientObligationsFormAction(sanitizedData, loginData));
    };
    var handleBackBtn = function () {
        navigate(isNonFirstAttempt ? "/questionnaire/overallExperience" : "/questionnaire/global");
    };
    useEffect(function () {
        if (success_clientObligations_form && isSubmitting) {
            navigate("/questionnaire/adviserObligations");
        }
    }, [success_clientObligations_form, isSubmitting, navigate]);
    return (_jsxs("div", __assign({ className: "" }, { children: [error && _jsx("div", __assign({ className: "error-message" }, { children: error })), _jsx(QuestionnaireOrg, { title: "Customer Expectations", content: "As a participant on this programme, you will be interacting with your adviser. In order to ensure that you get the best from the relationship with your adviser, we want to understand what you feel you have committed to do, but also what they have committed to do, to support to towards employment. Please respond truthfully and trust your initial reactions to the following statements.", data: clientObligationsData, responses: clientObligationsFormData, loading: !clientObligationsData || clientObligationsData.length === 0, handleSubmit: handleFormSubmit, handleBackBtn: handleBackBtn, classname: "clientObligations-w", width: getQuestionnaireProgressWidth("clientObligations", getQuestionnaireAttemptVariant(quesAttemptDetails)) })] })));
}
export default ClientObligationsQuestionnaire;
